<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'chart-bar']" />
        <span class="title">Results</span>
      </Header>
      <v-row>
        <v-col class="col-4">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr v-for="item in event" :key="item.name">
                  <td>
                    <font-awesome-icon :icon="item.icon" />
                  </td>
                  <td>{{ item.label }}</td>
                  <td>{{ item.n }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th>&nbsp;</th>
                  <th colspan="2">Route</th>
                </tr>
                <tr>
                  <th>Class</th>
                  <td>Checked</td>
                  <td>Not checked</td>
                </tr>
                <tr>
                  <td>Checked</td>
                  <td>{{ cross[3] }}</td>
                  <td>{{ cross[2] }}</td>
                </tr>
                <tr>
                  <td>Not checked</td>
                  <td>{{ cross[1] }}</td>
                  <td>{{ cross[0] }}</td>
                </tr>
              </tbody></template
            ></v-simple-table
          >
        </v-col>
        <v-col class="col-6">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Straat</th>
                  <th><img src="../assets/images/direction_left.jpg" /></th>
                  <th><img src="../assets/images/direction_straight.jpg" /></th>
                  <th><img src="../assets/images/direction_right.jpg" /></th>
                  <th><img src="../assets/images/direction_uturn.jpg" /></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="row in project.direction" :key="row.name">
                  <td class="tdname">
                    {{ row.legname }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";

export default {
  data() {
    return {
      event: {},
      height: 840,
      cross: {},
      project: {}
    };
  },
  components: {
    Header
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "results"
      })
        .then(response => {
          console.log(response.data);
          //this.event = response.data["classes"];
          //this.cross = response.data["status"];
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    }
  }
};
</script>
<style scoped>
.v-input {
  width: 50px;
}

img {
  height: 50px;
}
</style>
